/**
 * CVD (Color Vision Deficiency) Simulation Module
 * Algorithms: Brettel 1997, Machado 2009, Daltonize
 * Exports: window.CVD
 */
!function(){"use strict";

/* === sRGB <-> Linear === */
function srgbToLinear(c){c/=255;return c<=.04045?c/12.92:Math.pow((c+.055)/1.055,2.4)}
function linearToSrgb(c){c=Math.max(0,Math.min(1,c));return Math.round(255*(c<=.0031308?12.92*c:1.055*Math.pow(c,1/2.4)-.055))}

/* === RGB <-> LMS (Hunt-Pointer-Estevez) === */
var RGB_TO_LMS=[
  [0.31399022,0.63951294,0.04649755],
  [0.15537241,0.75789446,0.08670142],
  [0.01775239,0.10944209,0.87256922]
];
var LMS_TO_RGB=[
  [ 5.47221206,-4.64196010, 0.16963708],
  [-1.12524190, 2.29317094,-0.16789520],
  [ 0.02980165,-0.19318073, 1.16364789]
];

function rgbToLms(r,g,b){
  var lr=srgbToLinear(r),lg=srgbToLinear(g),lb=srgbToLinear(b);
  return[
    RGB_TO_LMS[0][0]*lr+RGB_TO_LMS[0][1]*lg+RGB_TO_LMS[0][2]*lb,
    RGB_TO_LMS[1][0]*lr+RGB_TO_LMS[1][1]*lg+RGB_TO_LMS[1][2]*lb,
    RGB_TO_LMS[2][0]*lr+RGB_TO_LMS[2][1]*lg+RGB_TO_LMS[2][2]*lb
  ];
}
function lmsToRgb(l,m,s){
  return[
    linearToSrgb(LMS_TO_RGB[0][0]*l+LMS_TO_RGB[0][1]*m+LMS_TO_RGB[0][2]*s),
    linearToSrgb(LMS_TO_RGB[1][0]*l+LMS_TO_RGB[1][1]*m+LMS_TO_RGB[1][2]*s),
    linearToSrgb(LMS_TO_RGB[2][0]*l+LMS_TO_RGB[2][1]*m+LMS_TO_RGB[2][2]*s)
  ];
}

/* === Brettel 1997 Simulation Matrices === */
/* Each type has two half-planes with projection matrices in LMS space */
var BRETTEL={
  protan:{
    rgbMatrix1:[[0.14980,0.10764,0.00384],[0.10764,0.84517,0.04243],[0.00384,0.04243,0.95373]],
    rgbMatrix2:[[0.14510,0.11440,0.00044],[0.11440,0.85316,0.03881],[0.00044,0.03881,0.96476]],
    separationPlane:[0.00048,0.00393,-0.00441]
  },
  deutan:{
    rgbMatrix1:[[0.36477,0.86381,-0.00023],[0.86381,0.64118,0.00028],[-0.00023,0.00028,1.00671]],
    rgbMatrix2:[[0.37298,0.85610,-0.00030],[0.85610,0.63300,0.00030],[-0.00030,0.00030,0.99340]],
    separationPlane:[-0.00281,-0.00611,0.00892]
  },
  tritan:{
    rgbMatrix1:[[1.01277,0.13548,-0.14474],[0.13548,0.86812,0.00030],[-0.14474,0.00030,0.15614]],
    rgbMatrix2:[[0.93678,0.18979,-0.12657],[0.18979,0.81020,0.00001],[-0.12657,0.00001,0.12656]],
    separationPlane:[0.03960,-0.02831,-0.01129]
  }
};

/* Brettel simulation for a single pixel (full severity) */
function brettelSim(lms,type){
  var b=BRETTEL[type];
  if(!b)return lms;
  var sep=b.separationPlane;
  var dotSep=lms[0]*sep[0]+lms[1]*sep[1]+lms[2]*sep[2];
  var mat=dotSep>=0?b.rgbMatrix1:b.rgbMatrix2;
  return[
    mat[0][0]*lms[0]+mat[0][1]*lms[1]+mat[0][2]*lms[2],
    mat[1][0]*lms[0]+mat[1][1]*lms[1]+mat[1][2]*lms[2],
    mat[2][0]*lms[0]+mat[2][1]*lms[1]+mat[2][2]*lms[2]
  ];
}

/* === Machado 2009 — precomputed matrices for severity 0.0-1.0 === */
/* Full severity matrices (severity=1.0) in linear RGB space */
var MACHADO_FULL={
  protan:[
    [0.152286,1.052583,-0.204868],
    [0.114503,0.786281,0.099216],
    [-0.003882,-0.048116,1.051998]
  ],
  deutan:[
    [0.367322,0.860646,-0.227968],
    [0.280085,0.672501,0.047413],
    [-0.011820,0.042940,0.968881]
  ],
  tritan:[
    [1.255528,-0.076749,-0.178779],
    [-0.078411,0.930809,0.147602],
    [0.004733,0.691367,0.303900]
  ]
};
/* Severity=0.5 matrices */
var MACHADO_HALF={
  protan:[
    [0.458064,0.679578,-0.137642],
    [0.092785,0.846313,0.060902],
    [-0.007494,-0.016807,1.024301]
  ],
  deutan:[
    [0.547494,0.607765,-0.155259],
    [0.181692,0.781742,0.036566],
    [-0.010410,0.027275,0.983136]
  ],
  tritan:[
    [1.017277,0.027029,-0.044306],
    [-0.006113,0.958479,0.047634],
    [0.006379,0.248708,0.744913]
  ]
};

/* Interpolate Machado severity: blend identity(0) -> half(0.5) -> full(1.0) */
function machadoMatrix(type,severity){
  severity=Math.max(0,Math.min(1,severity));
  if(severity===0)return[[1,0,0],[0,1,0],[0,0,1]];
  var full=MACHADO_FULL[type],half=MACHADO_HALF[type];
  if(!full)return[[1,0,0],[0,1,0],[0,0,1]];
  var mat=[[0,0,0],[0,0,0],[0,0,0]];
  var I=[[1,0,0],[0,1,0],[0,0,1]];
  if(severity<=0.5){
    var t=severity/0.5;
    for(var i=0;i<3;i++)for(var j=0;j<3;j++)
      mat[i][j]=I[i][j]*(1-t)+half[i][j]*t;
  }else{
    var t2=(severity-0.5)/0.5;
    for(var i2=0;i2<3;i2++)for(var j2=0;j2<3;j2++)
      mat[i2][j2]=half[i2][j2]*(1-t2)+full[i2][j2]*t2;
  }
  return mat;
}

/* Apply Machado matrix in linear RGB */
function machadoSim(r,g,b,type,severity){
  var lr=srgbToLinear(r),lg=srgbToLinear(g),lb=srgbToLinear(b);
  var mat=machadoMatrix(type,severity);
  return[
    linearToSrgb(mat[0][0]*lr+mat[0][1]*lg+mat[0][2]*lb),
    linearToSrgb(mat[1][0]*lr+mat[1][1]*lg+mat[1][2]*lb),
    linearToSrgb(mat[2][0]*lr+mat[2][1]*lg+mat[2][2]*lb)
  ];
}

/* === Achromatopsia (monochromacy) === */
function achromaSim(r,g,b,severity){
  var lr=srgbToLinear(r),lg=srgbToLinear(g),lb=srgbToLinear(b);
  var gray=0.2126*lr+0.7152*lg+0.0722*lb;
  var s=Math.max(0,Math.min(1,severity));
  return[
    linearToSrgb(lr*(1-s)+gray*s),
    linearToSrgb(lg*(1-s)+gray*s),
    linearToSrgb(lb*(1-s)+gray*s)
  ];
}

/* === Main simulate function === */
/* type: 'protan','deutan','tritan','achroma' */
/* severity: 0.0 (normal) to 1.0 (full deficiency) */
function simulate(r,g,b,type,severity){
  if(typeof severity==='undefined')severity=1;
  if(type==='achroma')return achromaSim(r,g,b,severity);
  if(severity>=0.95){
    // Full Brettel for maximum accuracy at full severity
    var lms=rgbToLms(r,g,b);
    var sim=brettelSim(lms,type);
    return lmsToRgb(sim[0],sim[1],sim[2]);
  }
  return machadoSim(r,g,b,type,severity);
}

/* === Daltonize (color enhancement for CVD users) === */
function daltonize(r,g,b,type,severity){
  if(typeof severity==='undefined')severity=1;
  var sim=simulate(r,g,b,type,severity);
  // Error between original and simulated
  var errR=r-sim[0],errG=g-sim[1],errB=b-sim[2];
  // Shift error into visible channels
  var shiftR=0,shiftG=0,shiftB=0;
  if(type==='protan'||type==='deutan'){
    shiftG=errR*0.7+errG;
    shiftB=errR*0.7+errB;
  }else if(type==='tritan'){
    shiftR=errB*0.7+errR;
    shiftG=errB*0.7+errG;
  }else{
    // achroma — boost saturation
    shiftR=errR;shiftG=errG;shiftB=errB;
  }
  return[
    Math.max(0,Math.min(255,Math.round(r+shiftR))),
    Math.max(0,Math.min(255,Math.round(g+shiftG))),
    Math.max(0,Math.min(255,Math.round(b+shiftB)))
  ];
}

/* === Process full ImageData === */
/* === Reveal: show a colour-deficient viewer what THEY cannot see ===========
   Simulation answers "how does this look to them", which is useless to the
   person who has that vision: for their own type the simulation looks identical
   to the original — that is the whole point of it. Daltonization moves the lost
   signal into other COLOUR channels, which helps but still asks the eye to
   judge colour.

   Reveal moves the lost signal into LIGHTNESS. Every kind of colour vision
   deficiency keeps luminance intact, so a figure re-expressed as light and dark
   is visible to everyone — which is exactly what someone staring at a
   pseudoisochromatic plate needs: not a picture of what a normal sees, but the
   hidden shape made visible in a channel they still have.

   Signed, not absolute: the projection keeps its sign so the figure and the
   ground move in opposite directions and a boundary becomes an edge rather than
   a uniform brightening. Requested by a visitor on 2026-09-04 who had just
   taken the colour vision test and could not work out where the figure was. */
function revealSignal(r,g,b,type,severity){
  var sim=simulate(r,g,b,type,severity);
  var errR=r-sim[0],errG=g-sim[1],errB=b-sim[2];
  if(type==='tritan') return errB-(errR+errG)*0.5;
  if(type==='achroma') return (errR-errG)+(errB-errG)*0.5;
  return errR-errG;                       // protan / deutan: the red-green axis
}
/* Single-pixel form, kept for callers that have no image to normalise against.
   `mid` and `scale` come from the image when there is one — without them the
   discarded signal's large DC offset pushes the whole picture to one end of the
   lightness range and the figure stays invisible. */
function revealLoss(r,g,b,type,severity,strength,mid,scale){
  if(typeof severity==='undefined')severity=1;
  if(typeof strength==='undefined')strength=1;
  var signed=revealSignal(r,g,b,type,severity);
  var m=(typeof mid==='number')?mid:0, sc=(typeof scale==='number'&&scale>0)?scale:120;
  var o=rgbToOklch(r,g,b);
  var L=Math.max(0.05,Math.min(0.98,o[0]+((signed-m)/sc)*0.34*strength));
  return oklchToRgb(L,o[1],o[2]);
}

function processImageData(imageData,type,severity,mode,strength){
  var d=imageData.data,len=d.length,i,c;
  if(mode==='reveal'){
    /* Two passes. The discarded signal carries a large DC offset that differs
       from image to image, so a fixed scale either does nothing or clips
       everything; the spread is measured from THIS image (5th-95th percentile,
       so a few extreme pixels cannot flatten the rest) and mapped onto the
       lightness range. */
    var hist=new Float32Array(len>>2), k=0, mn=Infinity, mx=-Infinity, v;
    for(i=0;i<len;i+=4){
      v=revealSignal(d[i],d[i+1],d[i+2],type,severity);
      hist[k++]=v; if(v<mn)mn=v; if(v>mx)mx=v;
    }
    var lo=mn,hi=mx;
    if(k>64){
      var BINS=256,bins=new Uint32Array(BINS),span=(mx-mn)||1,j;
      for(j=0;j<k;j++) bins[Math.min(BINS-1,Math.max(0,((hist[j]-mn)/span*BINS)|0))]++;
      var need=k*0.05,acc=0;
      for(j=0;j<BINS;j++){acc+=bins[j];if(acc>=need){lo=mn+span*j/BINS;break;}}
      acc=0;
      for(j=BINS-1;j>=0;j--){acc+=bins[j];if(acc>=need){hi=mn+span*(j+1)/BINS;break;}}
    }
    var mid=(lo+hi)/2, scale=Math.max(6,(hi-lo)/2);
    k=0;
    for(i=0;i<len;i+=4){
      c=revealLoss(d[i],d[i+1],d[i+2],type,severity,strength,mid,scale);
      d[i]=c[0];d[i+1]=c[1];d[i+2]=c[2];
    }
    return imageData;
  }
  var fn=(mode==='daltonize')?daltonize:simulate;
  for(i=0;i<len;i+=4){
    c=fn(d[i],d[i+1],d[i+2],type,severity);
    d[i]=c[0];d[i+1]=c[1];d[i+2]=c[2];
  }
  return imageData;
}

/* === WCAG Contrast === */
function relativeLuminance(r,g,b){
  var lr=srgbToLinear(r),lg=srgbToLinear(g),lb=srgbToLinear(b);
  return 0.2126*lr+0.7152*lg+0.0722*lb;
}
function contrastRatio(rgb1,rgb2){
  var l1=relativeLuminance(rgb1[0],rgb1[1],rgb1[2]);
  var l2=relativeLuminance(rgb2[0],rgb2[1],rgb2[2]);
  var lighter=Math.max(l1,l2),darker=Math.min(l1,l2);
  return(lighter+0.05)/(darker+0.05);
}

/* === CIEDE2000 Delta-E === */
/* RGB -> Lab */
function rgbToLab(r,g,b){
  var lr=srgbToLinear(r),lg=srgbToLinear(g),lb=srgbToLinear(b);
  // XYZ (D65)
  var x=(0.4124564*lr+0.3575761*lg+0.1804375*lb)/0.95047;
  var y=(0.2126729*lr+0.7151522*lg+0.0721750*lb)/1.00000;
  var z=(0.0193339*lr+0.1191920*lg+0.9503041*lb)/1.08883;
  function f(t){return t>0.008856?Math.pow(t,1/3):7.787*t+16/116}
  var fx=f(x),fy=f(y),fz=f(z);
  return[116*fy-16,500*(fx-fy),200*(fy-fz)];
}

function deltaE2000(lab1,lab2){
  var L1=lab1[0],a1=lab1[1],b1=lab1[2];
  var L2=lab2[0],a2=lab2[1],b2=lab2[2];
  var kL=1,kC=1,kH=1;
  var C1=Math.sqrt(a1*a1+b1*b1),C2=Math.sqrt(a2*a2+b2*b2);
  var Cb=(C1+C2)/2;
  var Cb7=Math.pow(Cb,7),t25_7=Math.pow(25,7);
  var G=0.5*(1-Math.sqrt(Cb7/(Cb7+t25_7)));
  var a1p=a1*(1+G),a2p=a2*(1+G);
  var C1p=Math.sqrt(a1p*a1p+b1*b1),C2p=Math.sqrt(a2p*a2p+b2*b2);
  var h1p=Math.atan2(b1,a1p)*180/Math.PI;if(h1p<0)h1p+=360;
  var h2p=Math.atan2(b2,a2p)*180/Math.PI;if(h2p<0)h2p+=360;
  var dLp=L2-L1,dCp=C2p-C1p;
  var dhp;
  if(C1p*C2p===0)dhp=0;
  else if(Math.abs(h2p-h1p)<=180)dhp=h2p-h1p;
  else if(h2p-h1p>180)dhp=h2p-h1p-360;
  else dhp=h2p-h1p+360;
  var dHp=2*Math.sqrt(C1p*C2p)*Math.sin(dhp*Math.PI/360);
  var Lbp=(L1+L2)/2,Cbp=(C1p+C2p)/2;
  var hbp;
  if(C1p*C2p===0)hbp=h1p+h2p;
  else if(Math.abs(h1p-h2p)<=180)hbp=(h1p+h2p)/2;
  else if(h1p+h2p<360)hbp=(h1p+h2p+360)/2;
  else hbp=(h1p+h2p-360)/2;
  var T=1-0.17*Math.cos((hbp-30)*Math.PI/180)+0.24*Math.cos(2*hbp*Math.PI/180)+0.32*Math.cos((3*hbp+6)*Math.PI/180)-0.20*Math.cos((4*hbp-63)*Math.PI/180);
  var SL=1+0.015*(Lbp-50)*(Lbp-50)/Math.sqrt(20+(Lbp-50)*(Lbp-50));
  var SC=1+0.045*Cbp;
  var SH=1+0.015*Cbp*T;
  var Cbp7=Math.pow(Cbp,7);
  var RT=-2*Math.sqrt(Cbp7/(Cbp7+t25_7))*Math.sin(60*Math.exp(-((hbp-275)/25)*((hbp-275)/25))*Math.PI/180);
  var p1=dLp/(kL*SL),p2=dCp/(kC*SC),p3=dHp/(kH*SH);
  return Math.sqrt(p1*p1+p2*p2+p3*p3+RT*p2*p3);
}

/* Perceptual distance between two RGB colors under CVD */
function cvdDistance(rgb1,rgb2,type,severity){
  var s1=simulate(rgb1[0],rgb1[1],rgb1[2],type,severity||1);
  var s2=simulate(rgb2[0],rgb2[1],rgb2[2],type,severity||1);
  return deltaE2000(rgbToLab(s1[0],s1[1],s1[2]),rgbToLab(s2[0],s2[1],s2[2]));
}

/* Check if two colors are distinguishable under all CVD types */
function isDistinguishable(rgb1,rgb2,threshold){
  threshold=threshold||10;
  var types=['protan','deutan','tritan'];
  for(var i=0;i<types.length;i++){
    if(cvdDistance(rgb1,rgb2,types[i],1)<threshold)return false;
  }
  return true;
}

/* === Hex helpers === */
function hexToRgb(hex){
  hex=hex.replace(/^#/,'');
  if(hex.length===3)hex=hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
  var n=parseInt(hex,16);
  return[(n>>16)&255,(n>>8)&255,n&255];
}
function rgbToHex(r,g,b){
  return'#'+((1<<24)+(r<<16)+(g<<8)+b).toString(16).slice(1);
}

/* === HSL helpers === */
function rgbToHsl(r,g,b){
  r/=255;g/=255;b/=255;
  var max=Math.max(r,g,b),min=Math.min(r,g,b);
  var h,s,l=(max+min)/2;
  if(max===min){h=s=0;}
  else{
    var d=max-min;
    s=l>0.5?d/(2-max-min):d/(max+min);
    if(max===r)h=((g-b)/d+(g<b?6:0))/6;
    else if(max===g)h=((b-r)/d+2)/6;
    else h=((r-g)/d+4)/6;
  }
  return[Math.round(h*360),Math.round(s*100),Math.round(l*100)];
}

/* === OKLCH helpers === */
function rgbToOklch(r,g,b){
  var lr=srgbToLinear(r),lg=srgbToLinear(g),lb=srgbToLinear(b);
  var l_=0.4122214708*lr+0.5363325363*lg+0.0514459929*lb;
  var m_=0.2119034982*lr+0.6806995451*lg+0.1073969566*lb;
  var s_=0.0883024619*lr+0.2817188376*lg+0.6299787005*lb;
  var l2=Math.cbrt(l_),m2=Math.cbrt(m_),s2=Math.cbrt(s_);
  var L=0.2104542553*l2+0.7936177850*m2-0.0040720468*s2;
  var a=1.9779984951*l2-2.4285922050*m2+0.4505937099*s2;
  var bv=0.0259040371*l2+0.7827717662*m2-0.8086757660*s2;
  var C=Math.sqrt(a*a+bv*bv);
  var h=Math.atan2(bv,a)*180/Math.PI;
  if(h<0)h+=360;
  return[L,C,h];
}

function oklchToRgb(L,C,h){
  var hRad=h*Math.PI/180;
  var a=C*Math.cos(hRad),bv=C*Math.sin(hRad);
  var l2=L+0.3963377774*a+0.2158037573*bv;
  var m2=L-0.1055613458*a-0.0638541728*bv;
  var s2=L-0.0894841775*a-1.2914855480*bv;
  var l_=l2*l2*l2,m_=m2*m2*m2,s_=s2*s2*s2;
  var lr=4.0767416621*l_-3.3077115913*m_+0.2309699292*s_;
  var lg=-1.2684380046*l_+2.6097574011*m_-0.3413193965*s_;
  var lb=-0.0041960863*l_-0.7034186147*m_+1.7076147010*s_;
  return[linearToSrgb(lr),linearToSrgb(lg),linearToSrgb(lb)];
}

/* === CVD types list === */
var TYPES=['protan','deutan','tritan','achroma'];
var ANOMALOUS_TYPES=['protan','deutan','tritan'];

/* === Export === */
window.CVD={
  simulate:simulate,
  daltonize:daltonize,
  revealLoss:revealLoss,
  revealSignal:revealSignal,
  processImageData:processImageData,
  contrastRatio:contrastRatio,
  relativeLuminance:relativeLuminance,
  deltaE2000:deltaE2000,
  cvdDistance:cvdDistance,
  isDistinguishable:isDistinguishable,
  rgbToLab:rgbToLab,
  rgbToLms:rgbToLms,
  lmsToRgb:lmsToRgb,
  rgbToHsl:rgbToHsl,
  rgbToOklch:rgbToOklch,
  oklchToRgb:oklchToRgb,
  hexToRgb:hexToRgb,
  rgbToHex:rgbToHex,
  machadoMatrix:machadoMatrix,
  TYPES:TYPES,
  ANOMALOUS_TYPES:ANOMALOUS_TYPES
};

}();
